import { RootState } from '@redux/store'

export const selectUserAccountType = ({ account }: RootState) =>
  account.accountMode

export const selectIsFamilyShareMode = ({ account }: RootState) =>
  account.isFamilyShareMode
